import { render, staticRenderFns } from "./SyaratKetentuanPanel.vue?vue&type=template&id=01213cec&"
import script from "./SyaratKetentuanPanel.vue?vue&type=script&lang=js&"
export * from "./SyaratKetentuanPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports